/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_Focus_UpperInputs */

const en_us2_quick_workout_focus_upper = /** @type {(inputs: Quick_Workout_Focus_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upper body`)
};

const pt_br2_quick_workout_focus_upper = /** @type {(inputs: Quick_Workout_Focus_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superior`)
};

const es_419_quick_workout_focus_upper = /** @type {(inputs: Quick_Workout_Focus_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tren superior`)
};

const pt_pt2_quick_workout_focus_upper = /** @type {(inputs: Quick_Workout_Focus_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superior`)
};

const fr_fr2_quick_workout_focus_upper = /** @type {(inputs: Quick_Workout_Focus_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haut du corps`)
};

const de_de2_quick_workout_focus_upper = /** @type {(inputs: Quick_Workout_Focus_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oberkörper`)
};

const it_it2_quick_workout_focus_upper = /** @type {(inputs: Quick_Workout_Focus_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parte superiore`)
};

/**
* | output |
* | --- |
* | "Upper body" |
*
* @param {Quick_Workout_Focus_UpperInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_focus_upper = /** @type {((inputs?: Quick_Workout_Focus_UpperInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Focus_UpperInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_focus_upper(inputs)
	if (locale === "es-419") return es_419_quick_workout_focus_upper(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_focus_upper(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_focus_upper(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_focus_upper(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_focus_upper(inputs)
	return en_us2_quick_workout_focus_upper(inputs)
});
export { quick_workout_focus_upper as "quick-workout.focus_upper" }